import _ from 'lodash';
import * as constants from '../../constants';

export const fetchBaseUrl = () => {
    let base_url = process.env.REACT_APP_WEBAPI_BASE;

    if (process.env.REACT_APP_ENV === 'staging') {
        base_url = process.env.REACT_APP_WEBAPI_STAGING;
    } else if (process.env.REACT_APP_ENV === 'test') {
        base_url = process.env.REACT_APP_WEBAPI_TEST;
    } else if (process.env.REACT_APP_ENV === 'production') {
        base_url = process.env.REACT_APP_WEBAPI_PRODUCTION;
    }

    return base_url;
};

export const makeRequest = async (props) => {
    let method = !_.isEmpty(props.method) ? props.method : 'GET';
    let payload = props.payload instanceof FormData || !_.isEmpty(props.payload) ? props.payload : null;
    let headers = !_.isEmpty(props.headers) ? props.headers : {};

    let fetchOptions = { method: method, headers: headers };

    if (!('Content-Type' in fetchOptions.headers) && !props.multipart) { fetchOptions.headers['Content-Type'] = 'application/json'; }

    if (props.payload instanceof FormData || !_.isEmpty(payload)) {
        fetchOptions.body = _.includes(fetchOptions.headers['Content-Type'], 'json') ? JSON.stringify(payload) : payload;
    }

    const response = await fetch(props.url, fetchOptions);

    try {
        const body = await response.text();
        let json = !_.isEmpty(body) ? JSON.parse(body) : null;

        if (response.status === 200) {
            return { status: response.status, body: json };
        } else {
            const message = _.isEmpty(json) ? response.statusText : json.message;
            return { status: response.status, message: message };
        }
    } catch {
        return { status: 500, message: constants.ERROR_GENERIC };
    }
};

export const processResponse = (response) => {
    if (!_.isEmpty(response)) {
        switch (response.status) {
            case 200: {
                return response;
            }
            default: {
                return response;
            }
        }
    } else {
        return { status: 500, body: { message: constants.ERROR_GENERIC } };
    }
};
